module.exports = {"140881001":"城西街道","140881002":"城北街道","140881003":"城东街道","140881100":"虞乡镇","140881101":"卿头镇","140881102":"开张镇","140881103":"栲栳镇","140881104":"蒲州镇","140881105":"韩阳镇","140881106":"张营镇","140881400":"永济监狱","140881401":"山西省永济虞乡强制隔离戒毒所","140881402":"山西省永济董村强制隔离戒毒所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140881.json
// module id = 432
// module chunks = 0